<template>
  <div class="phone-bar-box" :class="{ hideBar }">
    <svg class="icon-svg" @click="chooseBar('show_nav')" v-show="!hideBar">
      <use xlink:href="#icon-bar" />
    </svg>
    <svg class="icon-svg" :class="{ disabled: chapter_num == 0 }" @click="switchPage(chapter_num - 1)"
      v-show="!hideBar">
      <use xlink:href="#icon-last" />
    </svg>
    <svg class="icon-svg" :class="{ disabled: chapter_num == intList.length - 1 }" v-show="!hideBar"
      @click="switchPage(chapter_num + 1)">
      <use xlink:href="#icon-next" />
    </svg>
    <div class="bar-box" @click="showBar()">
      <svg class="icon-svg">
        <use xlink:href="#icon-yuanxi" />
      </svg>
    </div>

    <template v-if="bar.show_nav">
      <textbookNav :phoneMode="true" class="phone-nav" @openCode="openCode($event)"
        @switchChapter="switchChapter($event)" @foldNav="chooseBar('show_nav')" @chooseChildNav="chooseChildNav($event)"
        v-if="isNewTextbook"></textbookNav>

      <pilotNav :phoneMode="true" class="phone-nav" @openCode="openCode($event)" @switchChapter="switchChapter($event)"
        @foldNav="chooseBar('show_nav')" v-else></pilotNav>
    </template>
  </div>
</template>

<script>

import achievementBox from "@/components/achievement/achievement-box/achievement-box.vue";
import pilotNav from '@/components/list/pilot-list/pilot-nav/pilot-nav.vue';
import textbookNav from '@/components/list/textbook-list/textbook-nav/textbook-nav.vue';

export default {
  name: "phoneBar",
  components: {
    pilotNav, textbookNav, achievementBox
  },
  data() {
    return {
      fromType: '',
      isNewTextbook: false,
    }
  },
  props: {
    returnNav: String,
    hideBar: Boolean,
    bar: Object,
    chapter_num: Number,
    intList: Array,
  },
  async mounted() {
    let { fromType, currentClass } = this.$store.state;
    this.fromType = fromType;
    this.isNewTextbook = currentClass.IsNewTextbook;
  },
  methods: {
    //返回列表
    returnList() {
      this.$emit('returnList', '');
    },
    //跳转首页
    returnHome() {
      window.location.href = 'https://yuanxi.online';
    },
    //打开code
    openCode(code) {
      this.chooseBar('show_nav');
      this.$emit('openCode', code);
    },
    //切换page
    switchPage(num) {
      this.$emit('switchChapter', num);
    },
    //选择章节
    switchChapter(num) {
      setTimeout(() => {
        this.chooseBar('show_nav'); 
      }, 500);
      this.$emit('switchChapter', num);
    },
    //显示导航
    showBar() {
      this.$emit('showBar', !this.hideBar);
    },
    //点击了ChildNav
    chooseChildNav(event) {
      setTimeout(() => {
        this.chooseBar('show_nav'); 
      }, 500);

      this.$emit('chooseChildNav', event)
    },

    //选择底部
    chooseBar(type) {
      let bar = this.bar;
      if (bar[type]) return bar[type] = false;

      for (const key in bar) { bar[key] = false }
      bar[type] = true;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./phone-bar.scss";
</style>